import { render, staticRenderFns } from "./ProjectCalendarSearchBar.vue?vue&type=template&id=45473bfe&"
import script from "./ProjectCalendarSearchBar.vue?vue&type=script&lang=ts&"
export * from "./ProjectCalendarSearchBar.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports